import { APIOutput, AppError, Input } from "@amzn/ask-legal-domain";

export interface APIResponse<T> {
    data: APIOutput<T>;
    httpStatusCode: number;
    statusText: string;
}

export function toDefaultRequestPayload<T>(body: T) {
    return {
        body: Input.create(body),
        response: true,
        headers: {}
    };
}

export function createApiNotImplementedResponse() {
    return {
        data: APIOutput.createErrorOutput(
            AppError.create(
                "Not Implemented yet",
                404
            )
        ),
        httpStatusCode: 404,
        statusText: "Not Implemented"
    };
}